<template>
  <v-card class="card">
    <v-card-title class="accent--text pb-4"><span class="card-title">Заявление</span></v-card-title>
    <v-card-text outlined tile class="border-top">
      <v-row class="px-3 pt-2">
        <template v-if="application.personalData?.id">
          <v-col cols="12" class="pt-4 px-0">
            <ApplicationRecovery
              v-if="application.applicationType?.id === 1"
              :application="application"
            />

            <ApplicationOrganizationTransfer
              v-if="application.applicationType?.id === 2"
              :application="application"
            />

            <ApplicationEducationTransfer
              v-if="application.applicationType?.id === 3"
              :application="application"
            />
          </v-col>

          <v-col cols="12" class="px-0">
            <Documents :application="application"/>
          </v-col>
        </template>

        <template v-else>
          <v-col cols="12" class="pt-3 px-0">
            <div class="accent--text">Нет данных</div>
          </v-col>
        </template>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>

import {Application} from "@/models";
import ApplicationEducationTransfer
  from "@/components/zvp/applicationRead/application-data-card/ApplicationEducationTransfer";
import ApplicationOrganizationTransfer
  from "@/components/zvp/applicationRead/application-data-card/ApplicationOrganizationTransfer";
import ApplicationRecovery from "@/components/zvp/applicationRead/application-data-card/ApplicationRecovery";
import Documents from "@/components/zvp/applicationRead/application-data-card/Documents";

export default {
  name: "PersonalDataCard",
  components: {Documents, ApplicationEducationTransfer, ApplicationOrganizationTransfer, ApplicationRecovery},
  props: {
    application: Application
  },
}
</script>

<style scoped>
.card {
  border-radius: 20px !important;
}

.card-title {
  word-break: normal !important;
}

.border-top {
  border: 0 !important;
  border-top: 1px solid rgba(0, 0, 0, 0.12) !important;
}
</style>
